import axiosClient from './axiosClient';

export const loginAdmin = (credentials) => {
  return axiosClient.post('/admin/login', credentials);
};

export const getProfile = () => {
  return axiosClient.get('/admin/profile');
};

export const registerAdmin = (payload) => {
  return axiosClient.post('/admin/register', payload);
};
 